import React from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    SurgeryTitle,
    SurgerySubTitle,
    DetailsMainContainerBlock,
    MainContainerItems,
} from './AccountDetails.styled';
import { territoryValue } from 'src/utils/util';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

const AccountDetails = ({ toggleCard, isAccountDetails }) => {
    // console.log("CheckAccountDteatils==",accountDetails);
    // const districtName = accountDetails.districtName;
    // const districtCode = accountDetails.districtCode;
    // const territoryName = accountDetails.territoryName;
    // const territoryCode = accountDetails.territoryCode;
    // const accountName = accountDetails.accountName;
    // const accountCode = accountDetails.accountCode;
    // const contact = accountDetails.contact;
    const { t } = useTranslation();

    const accountDetails = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
    );
    const accountDetail = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails
    );
    const isFromOrderHistory = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.isFromOrderHistory
    );
    const derivedTerritoryDetails = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                ?.derivedTerritoryDetails
    );
    const { accountName, accountNumber } = accountDetail || {};

    const {
        contact,
        districtCode,
        districtName,
        territoryCode,
        territoryName,
    } = accountDetails || {};
    const isEquityOrderHistorySummary =
        isFromOrderHistory && accountDetail?.currentOrderType === 'ZOR';
  const isCondensedView = useSelector(
            (state) => state.loginReducer.isCondensedView
        );
    return (
        <>
            <CollapsableCard
                id="orders-accountDetails-accountDetails-details"
                title={t('ConsignmentAdd.submit.accountDetails')}
                onClick={() =>
                    toggleCard('isAccountDetails', !isAccountDetails)
                }
                isExpanded={isAccountDetails}
                padding={'0.8rem'}
                cursor={'pointer'}
                mobileMargin={ isCondensedView && '10px 16px 2px 16px'}

                // CollapsableCardIconWidthHeight={'12px'}
            >
                {isAccountDetails && accountDetails ? (
                    <DetailsMainContainerBlock>
                        {!isFromOrderHistory && (districtName || districtCode) ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('ConsignmentAdd.submit.district')}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {districtName ? districtName : null}{' '}
                                    {districtCode ? districtCode : null}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {!isEquityOrderHistorySummary && derivedTerritoryDetails ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('ConsignmentAdd.submit.territory')}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {territoryValue(derivedTerritoryDetails)}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : !isEquityOrderHistorySummary ? (
                            territoryName || territoryCode ? <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                {t('ConsignmentAdd.submit.territory')}
                                </SurgeryTitle>
                                <SurgerySubTitle>
                                    {territoryName} {territoryCode}
                                </SurgerySubTitle>
                            </MainContainerItems> : null
                        ) : null}

                        {accountName || accountNumber ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('ConsignmentAdd.submit.account')}
                                </SurgeryTitle>
                                <SurgerySubTitle className="orders-account-dt-mask">
                                    {accountName ? accountName : null}{' '}
                                    {accountNumber
                                        ? accountNumber.replace(/^0+/, '')
                                        : null}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {!isFromOrderHistory && accountDetail.billToName ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('ConsignmentAdd.billToDetails.title')}
                                </SurgeryTitle>
                                <SurgerySubTitle className="orders-account-dt-mask">
                                    {accountDetail.billToName}{''}
                                    {accountNumberZeroTrimmer(
                                    accountDetail.billToNumber)}
                                </SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                        {!isFromOrderHistory && contact ? (
                            <MainContainerItems setMarginBottom={true}>
                                <SurgeryTitle showAstrisk={false}>
                                    {t('scheduleSurgery.surgery.SurgeryReviewAndSuccess.contact')}
                                </SurgeryTitle>
                                <SurgerySubTitle className="orders-contact-dt-mask">{contact}</SurgerySubTitle>
                            </MainContainerItems>
                        ) : null}
                    </DetailsMainContainerBlock>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default AccountDetails;
